import { Injectable } from '@angular/core';
import { AjaxService } from './ajax.service';
import { Observable } from 'rxjs';

@Injectable()
export class TestChartService {
  private $api: string = '';

  constructor(private $ajax: AjaxService) {
    this.$api = $ajax.getAPIDomain();
  }

  /**
   * 아동 검사 결과 설명 획득
   */
  getTestExplanation(bmiNum: number): Observable<any> {
    return this.$ajax.httpRequest(
      'GET',
      this.$api + `test-explanation/${bmiNum}`,
    );
  }

  /**
   * 뇌 균형도 설명 획득
   */
  getBrainBalanceExplanation(bmiNum: number): Observable<any> {
    return this.$ajax.httpRequest(
      'GET',
      this.$api + `brain-balance-explanation/${bmiNum}`,
    );
  }
}
